import React, { useState } from 'react';
import { Icon } from '@iconify/react';
import PersonalInformation from './PersonalInformation';
import ChangePassword from './ChangePassword';
import AdminPage from '../../../components/admin/AdminPage';

function UserProfile() {
  const [activeTab, setActiveTab] = useState('personal');

  const tabs = [
    {
      id: 'personal',
      label: 'Personal Information',
      icon: 'fluent:person-24-regular',
      component: PersonalInformation,
    },
    {
      id: 'password',
      label: 'Change Password',
      icon: 'fluent:key-24-regular',
      component: ChangePassword,
    },
  ];

  return (
    <AdminPage
      title="Profile"
      description="View and update your personal information, account details, and password."
    >
      <div className="bg-white rounded-2xl shadow-sm border border-gray-100 overflow-hidden">
        {/* Tabs Navigation */}
        <div className="border-b border-gray-100 bg-gray-50/60">
          <nav className="flex gap-1 px-2 pt-2">
            {tabs.map((tab) => {
              const isActive = activeTab === tab.id;
              return (
                <button
                  key={tab.id}
                  type="button"
                  onClick={() => setActiveTab(tab.id)}
                  className={`inline-flex items-center gap-2 rounded-t-xl px-4 py-2.5 text-sm font-medium border-b-2 transition-colors ${
                    isActive
                      ? 'bg-white text-[#4F6BFF] border-[#4F6BFF]'
                      : 'bg-transparent text-gray-600 border-transparent hover:text-gray-900'
                  }`}
                >
                  <Icon icon={tab.icon} width="18" height="18" className="text-current" />
                  <span>{tab.label}</span>
                </button>
              );
            })}
          </nav>
        </div>

        {/* Tab Content */}
        <div className="p-4 sm:p-6">
          {tabs.map((tab) => {
            const Component = tab.component;
            return (
              <div
                key={tab.id}
                className={activeTab === tab.id ? 'block' : 'hidden'}
              >
                <Component />
              </div>
            );
          })}
        </div>
      </div>
    </AdminPage>
  );
}

export default UserProfile;